import { Component, Input, OnInit, signal, computed, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonHeader, IonContent, IonList, IonItem, IonCheckbox, IonFooter, IonLabel, ModalController } from '@ionic/angular/standalone';
import { SelectOptionMultiple } from './multiselect.component';
import { IconComponent } from "../icon/icon.component";
import { CheckboxComponent } from '../checkbox/checkbox.component';

@Component({
  selector: 'lib-multiselect-modal',
  imports: [
    CommonModule,
    FormsModule,
    IonHeader, 
    IonContent, 
    IonList, 
    IonItem, 
    IonCheckbox,
    IonFooter, IonLabel,
    IconComponent, CheckboxComponent
],
  templateUrl: './multiselect-modal.component.html',
  styleUrl: './multiselect-modal.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class MultiselectModalComponent implements OnInit {

  @Input() options: SelectOptionMultiple[] = [];
  @Input() selected: string[] = [];
  @Input() title = 'Selecciona';
  @Input() selectAllLabel = 'Seleccionar todos';
  @Input() deselectAllLabel = 'Deseleccionar todos';

  searchQuery = signal('');
  workingSelected = signal<string[]>([]);

  private modalCtrl = new ModalController();

  constructor(modalCtrl: ModalController) {
    this.modalCtrl = modalCtrl;
  }

  ngOnInit() {
    this.workingSelected.set([...this.selected]);
  }

  filteredOptions = computed(() => {
    const q = this.searchQuery().toLowerCase().trim();
    if (!q) return this.options;
    return this.options.filter(o => o.label.toLowerCase().includes(q));
  });

  enabledOptions = computed(() =>
    this.options.filter(o => !o.disabled)
  );

  isAllSelected = computed(() =>
    this.enabledOptions().length > 0 &&
    this.enabledOptions().every(o => this.workingSelected().includes(o.value))
  );

  isSelected(value: string): boolean {
    return this.workingSelected().includes(value);
  }

  toggleOption(value: string) {
    const current = this.workingSelected();
    if (current.includes(value)) {
      this.workingSelected.set(current.filter(v => v !== value));
    } else {
      this.workingSelected.set([...current, value]);
    }
  }

  toggleSelectAll() {
    if (this.isAllSelected()) {
      this.workingSelected.set([]);
    } else {
      this.workingSelected.set(this.enabledOptions().map(o => o.value));
    }
  }

  onSearchChange(event: any) {
    this.searchQuery.set((event.target as HTMLInputElement).value ?? '');
  }

  confirm() {
    this.modalCtrl.dismiss(this.workingSelected(), 'confirm');
  }

  cancel() {
    this.modalCtrl.dismiss(null, 'cancel');
  }
}